import {
  LOAD_DOMAINS,
  LOAD_DOMAINS_FAIL,
  LOAD_DOMAINS_SUCCESS, LOAD_ZONES, LOAD_ZONES_FAIL, LOAD_ZONES_SUCCESS,
  LoadDomainsSuccess, LoadZonesFail, LoadZonesSuccess
} from '../actions/hosting-domains.action';
import {DomainAction} from "../actions";
import {HostingDomainData} from "../../websites/website/hosting/domains/hostingDomainData";

export interface IHostingEntityState {
  domainEntities: {[websiteId: number]: HostingDomainData};
  loading: boolean;
  loaded: boolean;
}

export interface IHostingDomainsState {
  entities: {[websiteId: number]: IHostingEntityState};
  zoneEntities: any;
  loading: boolean;
  loaded: boolean;
}

export const initialState: IHostingDomainsState = {
  entities: {},
  zoneEntities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IHostingDomainsState = initialState, action: DomainAction): IHostingDomainsState {
  let payload: any;

  switch (action.type) {

    case LOAD_DOMAINS:
      payload = (<LoadDomainsSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            domainEntities: {},
            zoneEntities: {},
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_DOMAINS_SUCCESS:
      payload = (<LoadDomainsSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            domainEntities: payload.domainEntities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_DOMAINS_FAIL:
      payload = (<LoadDomainsSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_ZONES:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_ZONES_SUCCESS:
      payload = (<LoadZonesSuccess>action).payload;

      return {
        ...state,
        zoneEntities: payload.zoneEntities,
        loading: false,
        loaded: true
      };

    case LOAD_ZONES_FAIL:
      payload = (<LoadZonesFail>action).payload;

      return {
        ...state,
        loading: false,
        loaded: true
      };

  }

  return state;
}
